import WPLoader from "./WPLoader";

export default WPLoader;